import { render, staticRenderFns } from "./AiAnswer.vue?vue&type=template&id=37c4f20e&scoped=true&"
import script from "./AiAnswer.vue?vue&type=script&lang=js&"
export * from "./AiAnswer.vue?vue&type=script&lang=js&"
import style0 from "./AiAnswer.vue?vue&type=style&index=0&id=37c4f20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c4f20e",
  null
  
)

export default component.exports